import React from 'react';
import styled from "styled-components";
import ExpandMore from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '../../../../../../components/Button';

export const Status = styled.div`
  border-radius: 5px;
  background-color:#fff;
  width:100%;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;

export const Body = styled.section`
  padding:2rem;
  position: relative;
`;

export const Header = styled.header`
  background-color: ${props =>  props.theme.primary};
  color:#fff;
  padding:1.5rem 2rem;
  border-radius: 5px 5px 0 0;
  display: flex;
  align-items: center;

  &.available {
    cursor:pointer;
  }
`;

export const HeaderTitle = styled.h2`
  && {
    font-family: Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif !important;
    font-size:18px;
    font-weight:700;
    margin:0;
    color:#ffffff;
    display:inline-block;
    margin-right: auto;
  }
`;

export const ExpandIcon = styled(props => <ExpandMore {...props} />)`
  && {
    margin-right: 8px;
    font-size: 26px;
    transition: transform 300ms ease;
  
    &.open {
      transform:rotate(180deg);
    }
  }
`;

export const DebriefState = styled.ul`
  margin:1rem 0 2rem 0;
  padding:0;
`;

export const DebriefStateItem = styled.li`
  list-style-type:none;
  padding-left:2.5rem;

  &.seperator {
    background-image: url('/seperator.svg');
    height:40px;
    background-repeat:no-repeat;
    margin-top:-10px;
    margin-bottom:10px;
  }

  &.circle-icon-check {
    @extend .circle-icon-blue;
  }

  &.circle-icon-check {
    @extend .circle-icon;

    &::before {
      content:"\\2713 ";
    }
  }
    
  &.circle-icon {
    position:relative;
    background-repeat: no-repeat;
  
    &::before {
      font-family:Roboto,sans !important;
      font-size:12px;
      font-weight:400;
      position: absolute;
      color:#ffffff;
      text-align:center;
      width:24px;
      left:0;
      top:3px;
      line-height:1.65; 
    }
  }

  &.circle-icon-gray {
    &::before {
      color:#5b6d74;
    }
    background-image: url('/circle-gray.svg');
  }

  &.circle-icon-blue {
    background-image: url('/circle-blue.svg');
    &::before {
        color:#ffffff;
    }
  }

  &.circle-icon-orange {
    &::before {
      color:#ffffff;
    }
    background-image: url('/circle-orange.svg');
  }
  
  &.icon-1 {
    background-image: url('/circle-gray.svg');
    &::before {
      color:#5b6d74;
      content:"1";
    }
  }
  
  &.icon-2 {
    background-image: url('/circle-gray.svg');
    &::before {
      color:#5b6d74;
      content:"2";
    }
  }
  
  &.icon-3 {
    background-image: url('/circle-gray.svg');
    &::before {
      color:#5b6d74;
      content:"3";
    }
  }
  
  &.icon-4 {
    background-image: url('/circle-gray.svg');
    &::before {
      color:#5b6d74;
      content:"4";
    }
  }
  
  &.icon-5 {
    background-image: url('/circle-gray.svg');
    &::before {
      color:#5b6d74;
      content:"5";
    }
  }

  &.icon--check {
    background-image: url('/circle-blue.svg');
    &::before {
        color:#fff;
        content:url('/check.png');
        left:1px;
        top:5px;
    }
  }
  
  &.icon--active {
    background-image: url('/circle-orange.svg');

    &::before {
      color:#ffffff;
      font-weight:700;
    }
  }
`;

export const DebriefStateItemTitle = styled.h3`
  && {
    font-family: Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif !important;
    font-size:18px;
    font-weight: ${props => props.active ? 700 : 300};
    color:#5b6d74;
    margin:0;
  }
`;

export const DebriefStateItemSubtitle = styled.span`
  font-size:12px;
  font-weight:normal;
  color: #8B989E;
`;

export const ContinueButton = styled(props => <Button {...props} />)`
  && {
    .MuiButton-label {
      font-size: 13px;
      text-transform: uppercase;
      font-weight: normal;
    }
  
    &.hidden {
      visibility:hidden;
    }
  }
`;

export const MenuIcon = styled(props => <MoreVertIcon {...props} />)`
  && {
    fill: #fff;
  }
`;

export const Dropdown = styled.ul`
  position: absolute;
  background-color: #fff;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 6px 11px 0 rgba(0, 0, 0, 0.11);
  top:0;
  left:0;
  right:0;
  list-style-type:none;
  z-index:10;
  padding:0;
  margin:0;
  max-height:0;
  overflow:hidden;
  transition: max-height 300ms ease;

  &.open {
    max-height:500px;
    overflow:auto;
  }
`;

export const DropdownItem = styled.li`
  padding:1rem 2.5rem;
  cursor:pointer;

  &:hover {
    background-color:#f0f0f0;
  }
`;

export const DropdownItemLabel = styled.h4`
  margin:0;
  font-size:16px;
`;

export const DropdownItemDots = styled.i`
  &.dot {
    display: inline-block;
    width:7px;
    height:7px;
    background-size: cover;
    margin-right: 7px;

    &.blue {
      background-image: url('/circle-blue.svg')
    }
    &.orange {
      background-image: url('/circle-orange.svg')
    }
    &.gray {
      background-image: url('/circle-gray.svg')
    }
  }
`;

export const DeleteMenu = styled(props => <Menu {...props} />)`
  .MuiPopover-paper {
    min-width: 175px;
  }

  .MuiList-padding {
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;

export const DeleteMenuItem = styled(props => <MenuItem {...props} />)`
  && {
    font-size: 16px;
    color: #3e3e3e;
    padding-right: 20px;
    padding-left: 20px;
    height: 40px;
  }
`;

export const DeleteIconContainer = styled.div`
  padding-right: 8px;
  padding-top: 4px;
  color: #cbcfd8;
`;


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DebriefStatus/style.js